import React from "react";
import { Table } from "react-bootstrap";

const ClientTable = ({ clients }) => {
  return (
    <Table bordered hover>
      <thead>
        <tr>
          <th>Client's Name</th>
          <th>BPID</th>
          <th>ISIN</th>
          <th>e-SIP Reference No.</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {clients.map((client, index) => (
          <tr key={index}>
            <td>{client.name}</td>
            <td>{client.bpId}</td>
            <td>{client.isin}</td>
            <td>{client.referenceNo}</td>
            <td>{client.amount}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ClientTable;
